module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "P_Basic-Paragraph__And__Spacing_After"
  }, [_vm._v("Copyright © 2015")]), _vm._v(" "), _c('p', {
    staticClass: "P_Basic-Paragraph__And__Spacing_After"
  }, [_vm._v("By Barbara Sillery")]), _vm._v(" "), _c('p', {
    staticClass: "P_Basic-Paragraph__And__Spacing_After"
  }, [_vm._v("All rights reserved")]), _vm._v(" "), _c('p', {
    staticClass: "P_Basic-Paragraph_para-style-override-6__And__Centre_Alignment__And__Spacing_After"
  }, [_c('span')]), _vm._v(" "), _c('p', {
    staticClass: "P_Basic-Paragraph_para-style-override-6__And__Centre_Alignment__And__Spacing_After"
  }, [_c('span', [_c('span', {
    staticClass: "C_span_char-style-override-10"
  }, [_vm._v("The word “Pelican” and the depiction of a pelican are")])])]), _vm._v(" "), _c('p', {
    staticClass: "P_Basic-Paragraph_para-style-override-6__And__Centre_Alignment__And__Spacing_After"
  }, [_c('span', [_c('span', {
    staticClass: "C_span_char-style-override-10"
  }, [_vm._v("trademarks of Pelican Publishing Company, Inc., and are")])])]), _vm._v(" "), _c('p', {
    staticClass: "P_Basic-Paragraph_para-style-override-6__And__Centre_Alignment__And__Spacing_After"
  }, [_c('span', [_c('span', {
    staticClass: "C_span_char-style-override-10"
  }, [_vm._v("registered in the U.S. Patent and Trademark Office.")])])]), _vm._v(" "), _c('p', {
    staticClass: "P_Basic-Paragraph_para-style-override-6__And__Spacing_After"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Basic-Paragraph_para-style-override-6__And__Centre_Alignment__And__Spacing_After"
  }, [_c('span', [_vm._v("Library of Congress Cataloging-in-Publication Data")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Basic-Paragraph__And__Spacing_After"
  }, [_vm._v("Sillery, Barbara.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Basic-Paragraph__And__Spacing_After"
  }, [_vm._v("Biloxi memories / by Barbara Sillery.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Basic-Paragraph__And__Spacing_After"
  }, [_vm._v("pages cm")]), _vm._v(" "), _c('p', {
    staticClass: "P_Basic-Paragraph__And__Spacing_After"
  }, [_vm._v("ISBN 978-1-4556-2067-8 (pbk. : alk. paper) -- ISBN 978-1-4556-2068-5 (e-book) 1. Biloxi (Miss.)--History. I. Title.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Basic-Paragraph__And__Spacing_After"
  }, [_vm._v("F349.B5S56 2015")]), _vm._v(" "), _c('p', {
    staticClass: "P_Basic-Paragraph__And__Spacing_After"
  }, [_vm._v("976.2’13--dc23")]), _vm._v(" "), _c('p', {
    staticClass: "P_Basic-Paragraph__And__Centre_Alignment__And__Spacing_After"
  }, [_c('span', [_vm._v("2015017176")])]), _vm._v(" "), _c('p', {
    staticClass: "P_div_frame-2__And__Left_Alignment__And__Spacing_After"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_div_frame-2__And__Left_Alignment__And__Spacing_After"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%",
      "max-height": "100%"
    },
    attrs: {
      "alt": "",
      "src": "image2.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "P_Basic-Paragraph_para-style-override-9__And__Spacing_After"
  }, [_vm._v("Printed in Singapore")]), _vm._v(" "), _c('p', {
    staticClass: "P_Basic-Paragraph__And__Spacing_After"
  }, [_vm._v("Published by Pelican Publishing Company, Inc.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Basic-Paragraph_para-style-override-4__And__Spacing_After"
  }, [_vm._v("1000 Burmaster Street, Gretna, Louisiana 70053")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-34aefee5","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/section0002.vue
// module id = 60
// module chunks = 0